import { render, staticRenderFns } from "./PoiSubHike.vue?vue&type=template&id=18ad3908"
import script from "./PoiSubHike.js?vue&type=script&lang=js&external"
export * from "./PoiSubHike.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports